export const stripEmojis = text => {
  // I tried using regex literal as per eslint's suggestion, but it didn't work and I still don't know why.
  const emojiRegex = new RegExp(/[^\p{L}\p{N}\p{P}\p{Z}^$\n]/, 'gu')
  return text.replace(emojiRegex, '')
}
